export default __webpack_public_path__ + "static/media/3057.0219d30d.jpg";